import {
  purchaseOrderFreightCreateAtom,
  purchaseOrderFreightUpdateAtom,
} from '~/modules/trade/_graphql/mutationPurchaseOrderFreight';
import {
  salesOrderFreightCreateAtom,
  salesOrderFreightUpdateAtom,
} from '~/modules/trade/_graphql/mutationSalesOrderFreight';

export const $createPurchaseOrderFreight = purchaseOrderFreightCreateAtom({});
export const $updatePurchaseOrderFreight = purchaseOrderFreightUpdateAtom({});
export const $createSalesOrderFreight = salesOrderFreightCreateAtom({});
export const $updateSalesOrderFreight = salesOrderFreightUpdateAtom({});
